import React, { Component } from "react";
import ReverseHex from "./tools/ReverseHex";
import ScriptPubkeyHash from "./tools/ScriptPubkeyHash";
import { AddressToScripthash } from "./tools/AddressToScripthash";
import Sha256Hash from "./tools/SHA256Hash";
import RIPEMD from "./tools/RIPEMD";
import TimestampConverter from "./tools/TimestampConverter";

export class Tools extends Component {
  static displayName = Tools.name;
  
  componentDidMount() {
    // Check localStorage to see if the refresh has already happened
    const hasRefreshed = localStorage.getItem('hasRefreshed');

    if (!hasRefreshed) {
      localStorage.setItem('hasRefreshed', 'true'); // Mark as refreshed
      window.location.reload(); // Refresh the page once
    }
  }

  render() {
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <Sha256Hash />
              
            </div>
            <div className="col-md-4">
               <RIPEMD />
            </div>
            <div className="col-md-4">
              <ReverseHex />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <AddressToScripthash />
            </div>
            <div className="col-md-4">
              <ScriptPubkeyHash />
            </div>
            <div className="col-md-4">
              <TimestampConverter />
            </div>
          </div>
        </div>
      </>
    );
  }
}
